import {TemplatesWebFrontendRequest} from "services-comun-ed/modules/services/templates/frontend-web";
import {IComponentWindow} from "./interface";
import {Auth} from "../firebase/auth";
import {AutenticacionPopupController} from "./autenticacion";
import {UserHeaderController} from "./inicio";
import {RestablecerPassInfoPopupController} from "./restablecer-pass-info";

export class RestablecerPassPopupController {

    /* INSTANCE */
    public static instance: RestablecerPassPopupController;
    private restablecer?: IComponentWindow;

    /* STATIC */
    public static async build(auth: Auth): Promise<RestablecerPassPopupController> {
        return RestablecerPassPopupController.instance = new this(auth);
    }

    private constructor(readonly auth: Auth) {
        TemplatesWebFrontendRequest.loginPopUpRestablecerPassword().then(async (response) => {
            const restablecer = new DOMParser().parseFromString(response.data, 'text/html').body.firstChild as HTMLElement;
            this.restablecer = {
                window: restablecer,
                inputs: {
                    email: restablecer.querySelector(".input-rt") as HTMLInputElement,
                },
                buttons: {
                    send_password: restablecer.querySelector("#btn-rt") as HTMLButtonElement,
                    back: restablecer.querySelector(".volver-container-rt") as HTMLButtonElement,
                    close: restablecer.querySelector(".circulo-rt") as HTMLButtonElement,
                }
            }
            await this.init();
            document.getElementsByTagName("body").item(0)?.appendChild(this.restablecer!.window);
        });
    }

    private async init(): Promise<void> {
        this.restablecer?.buttons?.send_password?.addEventListener("click", async () => {
            const email = this.restablecer?.inputs?.email?.value;
            await this.auth.resetPassword(email as string);
            this.restablecer!.window.style.display = "none";
            const popupInfo = await RestablecerPassInfoPopupController.instance.getComponent();
            popupInfo.window.style.display = "block";
            const textoDesc = popupInfo.window.querySelector(".texto-descripcion-rt-info") as HTMLElement;
            const strongElement = document.createElement('strong');
            strongElement.textContent = email as string;
            const textoAntes = textoDesc.textContent?.slice(0, 25);
            const textoDespues = textoDesc.textContent?.slice(25);
            textoDesc.innerHTML = textoAntes + strongElement.outerHTML + textoDespues;
            UserHeaderController.instance.createOverlay(popupInfo.window);
        });
        this.restablecer?.buttons?.back?.addEventListener("click", async () => {
            this.restablecer!.window.style.display = "none";
            const login = AutenticacionPopupController.instance.getComponent();
            UserHeaderController.instance.createOverlay(login.window);
            login.window.style.display = "block";
        });
        this.restablecer?.buttons?.close?.addEventListener("click", async () => {
            this.restablecer!.window.style.display = "none";
            UserHeaderController.instance.destroyOverlay();
        });
    }

    public async getComponent(): Promise<IComponentWindow> {
        return this.restablecer as IComponentWindow;
    }

}
